import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export class JSONUtils {
  static parse(data: unknown) {
    try {
      return JSON.parse(data as string);
    } catch (error) {
      return null;
    }
  }
}
